import { cn } from "@/lib/utils";

export function Card({ className, children, ...rest }) {
  return (
    <div
      className={cn(
        "rounded-2xl border border-slate-800 bg-[#131C2E]/80 p-4 shadow-xl shadow-black/20",
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export function FieldLabel({ children, right }) {
  return (
    <div className="mb-2 flex items-center justify-between">
      <span className="text-[11px] font-bold uppercase tracking-wider text-slate-400">{children}</span>
      {right}
    </div>
  );
}

// Segmented pill toggle. options: [{ value, label, sub }]
export function Pills({ value, options, onChange, testid, size = "md" }) {
  return (
    <div className="flex flex-wrap gap-2 overflow-x-auto no-scrollbar">
      {options.map((o) => {
        const on = value === o.value;
        return (
          <button
            key={o.value}
            data-testid={testid ? `${testid}-${o.value}` : undefined}
            onClick={() => onChange(o.value)}
            className={cn(
              "shrink-0 rounded-xl border px-4 font-semibold transition-all",
              size === "md" ? "py-2.5 text-sm" : "py-2 text-xs",
              on
                ? "border-orange-500 bg-orange-500 text-slate-950 shadow-lg shadow-orange-500/25"
                : "border-slate-700 bg-slate-900/50 text-slate-300 hover:border-slate-600 hover:text-white"
            )}
          >
            <span className="block leading-tight">{o.label}</span>
            {o.sub && (
              <span className={cn("block text-[10px] font-medium", on ? "text-slate-800" : "text-slate-500")}>
                {o.sub}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export function Stat({ label, value, unit, accent, testid }) {
  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/50 p-3">
      <div className="text-[10px] font-bold uppercase tracking-wider text-slate-500">{label}</div>
      <div
        data-testid={testid}
        className={cn("mt-1 font-mono text-xl font-extrabold leading-none", accent ? "text-orange-400" : "text-white")}
      >
        {value}
        {unit && <span className="ml-1 text-xs font-semibold text-slate-500">{unit}</span>}
      </div>
    </div>
  );
}
